// import { React } from "react";


// const BeforeAfterPlanSummaryTable = ({ beforeLID, afterLID, tableHeaderStyle, tableCellStyle }) => {
//     return (
//         <>
//             {(beforeLID && afterLID) && (
//                 <table style={{ width: '80%', borderCollapse: 'collapse', marginTop: '20px', color: '#fff', border: '1px solid #fff' }}>
//                     <thead>
//                         <tr>
//                             <th style={tableHeaderStyle}>Development Plan Summary</th>
//                             <th style={tableHeaderStyle}>Before</th>
//                             <th style={tableHeaderStyle}>After</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {Object.keys(beforeLID).map((location) => {
//                             const rbKeysBefore = Object.keys(beforeLID[location] || {});
//                             const rbKeysAfter = Object.keys(afterLID[location] || {});
//                             const maxRows = Math.max(rbKeysBefore.length, rbKeysAfter.length);

//                             return rbKeysBefore.map((rbKey, idx) => (
//                                 <tr key={`${location}-${idx}`}>
//                                     {idx === 0 && (
//                                         <td style={{ ...tableCellStyle, fontWeight: 'bold' }} rowSpan={maxRows}>
//                                             {location}
//                                         </td>
//                                     )}
//                                     <td style={tableCellStyle}>
//                                         {rbKey || "-"}
//                                     </td>
//                                     <td style={tableCellStyle}>
//                                         {rbKeysAfter[idx] || "-"}
//                                     </td>
//                                 </tr>
//                             ));
//                         })}
//                         <tr>
//                             <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Area</td>
//                             <td style={tableCellStyle}>
//                                 {Object.values(beforeLID).flatMap(loc => Object.values(loc).map(rb => rb.area)).reduce((a, b) => a + b, 0).toFixed(2)}
//                             </td>
//                             <td style={tableCellStyle}>
//                                 {Object.values(afterLID).flatMap(loc => Object.values(loc).map(rb => rb.area)).reduce((a, b) => a + b, 0).toFixed(2)}
//                             </td>
//                         </tr>
//                         <tr>
//                             <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Quantity</td>
//                             <td style={tableCellStyle}>
//                                 {Object.values(beforeLID).flatMap(loc => Object.values(loc).map(rb => rb.n_replicate)).reduce((a, b) => a + b, 0)}
//                             </td>
//                             <td style={tableCellStyle}>
//                                 {Object.values(afterLID).flatMap(loc => Object.values(loc).map(rb => rb.n_replicate)).reduce((a, b) => a + b, 0)}
//                             </td>
//                         </tr>
//                     </tbody>
//                 </table>
//             )}
//         </>
//     )
// }


// export default BeforeAfterPlanSummaryTable;


// import React from "react";

// const BeforeAfterPlanSummaryTable = ({ beforeLID, afterLID, tableHeaderStyle, tableCellStyle }) => {
//     // Mapping for LID types
//     const lidTypeMapping = {
//         RG1: "Rain Garden",
//         Planter: "Tree Planter",
//         GR1: "Green Roof",
//         RB12: "Rain Barrel"
//     };

//     // Extract subcatchments (locations)
//     const subcatchmentsBefore = Object.keys(beforeLID || {});
//     const subcatchmentsAfter = Object.keys(afterLID || {});

//     // Extract and map Added Infrastructure (RB Keys)
//     const addedInfraBefore = subcatchmentsBefore.flatMap(loc => 
//         Object.keys(beforeLID[loc] || {}).map(rbKey => lidTypeMapping[rbKey] || "Unknown")
//     );

//     const addedInfraAfter = subcatchmentsAfter.flatMap(loc => 
//         Object.keys(afterLID[loc] || {}).map(rbKey => lidTypeMapping[rbKey] || "Unknown")
//     );

//     // Calculate total area and quantity (n_replicate) for before and after
//     const totalAreaBefore = subcatchmentsBefore
//         .flatMap(loc => Object.values(beforeLID[loc] || {}).map(rb => rb.area))
//         .reduce((sum, val) => sum + val, 0).toFixed(2);

//     const totalAreaAfter = subcatchmentsAfter
//         .flatMap(loc => Object.values(afterLID[loc] || {}).map(rb => rb.area))
//         .reduce((sum, val) => sum + val, 0).toFixed(2);

//     const totalQuantityBefore = subcatchmentsBefore
//         .flatMap(loc => Object.values(beforeLID[loc] || {}).map(rb => rb.n_replicate))
//         .reduce((sum, val) => sum + val, 0);

//     const totalQuantityAfter = subcatchmentsAfter
//         .flatMap(loc => Object.values(afterLID[loc] || {}).map(rb => rb.n_replicate))
//         .reduce((sum, val) => sum + val, 0);

//     return (
//         <>
//             {(beforeLID && afterLID) && (
//                 <table style={{ width: '80%', borderCollapse: 'collapse', marginTop: '20px', color: '#fff', border: '1px solid #fff' }}>
//                     <thead>
//                         <tr>
//                             <th style={tableHeaderStyle}>Development Plan Summary</th>
//                             <th style={tableHeaderStyle}>Before</th>
//                             <th style={tableHeaderStyle}>After</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {/* Subcatchment (Location) Row */}
//                         <tr>
//                             <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Subcatchment</td>
//                             <td style={tableCellStyle}>{subcatchmentsBefore.join(", ") || "-"}</td>
//                             <td style={tableCellStyle}>{subcatchmentsAfter.join(", ") || "-"}</td>
//                         </tr>

//                         {/* Added Infrastructure (Mapped RB Keys) Row */}
//                         <tr>
//                             <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Added Infrastructure</td>
//                             <td style={tableCellStyle}>{addedInfraBefore.join(", ") || "-"}</td>
//                             <td style={tableCellStyle}>{addedInfraAfter.join(", ") || "-"}</td>
//                         </tr>

//                         {/* Area Row */}
//                         <tr>
//                             <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Area (sq. ft)</td>
//                             <td style={tableCellStyle}>{totalAreaBefore}</td>
//                             <td style={tableCellStyle}>{totalAreaAfter}</td>
//                         </tr>

//                         {/* Quantity Row */}
//                         <tr>
//                             <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Quantity</td>
//                             <td style={tableCellStyle}>{totalQuantityBefore}</td>
//                             <td style={tableCellStyle}>{totalQuantityAfter}</td>
//                         </tr>
//                     </tbody>
//                 </table>
//             )}
//         </>
//     )
// }

// export default BeforeAfterPlanSummaryTable;




import React from "react";

const BeforeAfterPlanSummaryTable = ({ beforeLID, afterLID, tableHeaderStyle, tableCellStyle }) => {
    const lidTypeMapping = {
        RG1: "Rain Garden",
        Planter: "Tree Planter",
        GR1: "Green Roof",
        RB12: "Rain Barrel"
    };

    const subcatchmentsBefore = Object.keys(beforeLID || {});
    const subcatchmentsAfter = Object.keys(afterLID || {});

    const addedInfraBefore = subcatchmentsBefore.flatMap(loc => 
        Object.keys(beforeLID[loc] || {}).map(rbKey => lidTypeMapping[rbKey] || "Unknown")
    );

    const addedInfraAfter = subcatchmentsAfter.flatMap(loc => 
        Object.keys(afterLID[loc] || {}).map(rbKey => lidTypeMapping[rbKey] || "Unknown")
    );

    const totalAreaBefore = subcatchmentsBefore
        .flatMap(loc => Object.values(beforeLID[loc] || {}).map(rb => rb.area))
        .reduce((sum, val) => sum + val, 0).toFixed(2);

    const totalAreaAfter = subcatchmentsAfter
        .flatMap(loc => Object.values(afterLID[loc] || {}).map(rb => rb.area))
        .reduce((sum, val) => sum + val, 0).toFixed(2);

    const totalQuantityBefore = subcatchmentsBefore
        .flatMap(loc => Object.values(beforeLID[loc] || {}).map(rb => rb.n_replicate))
        .reduce((sum, val) => sum + val, 0);

    const totalQuantityAfter = subcatchmentsAfter
        .flatMap(loc => Object.values(afterLID[loc] || {}).map(rb => rb.n_replicate))
        .reduce((sum, val) => sum + val, 0);

    return (
        <>
            {(beforeLID && afterLID) && (
                <table style={{
                    width: '80%', borderCollapse: 'collapse', marginTop: '20px', 
                    color: '#FFFFFF', border: '2px solid #2196F3', backgroundColor: '#121212'
                }}>
                    <thead>
                        <tr style={{ backgroundColor: '#1E1E1E' }}>
                            <th style={tableHeaderStyle}>Development Plan Summary</th>
                            <th style={tableHeaderStyle}>Before</th>
                            <th style={tableHeaderStyle}>After</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Subcatchment</td>
                            <td style={tableCellStyle}>{subcatchmentsBefore.join(", ") || "-"}</td>
                            <td style={tableCellStyle}>{subcatchmentsAfter.join(", ") || "-"}</td>
                        </tr>
                        <tr>
                            <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Added Infrastructure</td>
                            <td style={tableCellStyle}>{addedInfraBefore.join(", ") || "-"}</td>
                            <td style={tableCellStyle}>{addedInfraAfter.join(", ") || "-"}</td>
                        </tr>
                        <tr>
                            <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Area (sq. ft)</td>
                            <td style={tableCellStyle}>{totalAreaBefore}</td>
                            <td style={tableCellStyle}>{totalAreaAfter}</td>
                        </tr>
                        <tr>
                            <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Quantity</td>
                            <td style={tableCellStyle}>{totalQuantityBefore}</td>
                            <td style={tableCellStyle}>{totalQuantityAfter}</td>
                        </tr>
                    </tbody>
                </table>
            )}
        </>
    );
}

export default BeforeAfterPlanSummaryTable;
